export default __webpack_public_path__ + "static/media/Squatting.86dfb770.pdf";